module.exports = __webpack_public_path__ + "static/media/dokstor-logo-svg.c77a9de9.svg";